import { ConsistentlyProvider } from "@fastly/consistently-vanilla"
import { themeConsistentlyLightV3 } from "@fastly/consistently-vanilla/tokens"

export const BrandRefreshProvider = ({ children }) => (
  <ConsistentlyProvider theme={themeConsistentlyLightV3} reset>
    {children}
  </ConsistentlyProvider>
)
